import { render } from "./login.vue?vue&type=template&id=05486327&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=05486327&lang=scss&scoped=true"

import exportComponent from "D:\\桌面\\报价系统\\quotesystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05486327"]])

export default __exports__